import { Component } from "@angular/core";
import { MatDialogRef } from "@angular/material/dialog";

@Component({
  selector: "app-refund",
  templateUrl: "./refund.component.html",
  styleUrls: ["./refund.component.scss"],
})
export class RefundComponent {
  form = {
    administrativeExpenses: 0,
  };

  constructor(private dialogRef: MatDialogRef<RefundComponent>) {}

  submit(): void {
    this.dialogRef.close(this.form);
  }

  close(): void {
    this.dialogRef.close();
  }
}
